import { useEffect, useState } from "react";
import { getPlanificaciones1 } from "../pages/operaciones/helpers/api.helper";

export function useIdTipoOperacion({ formValues, id }) {
  const [loadingData, setLoadingData] = useState(null);
  const [error, setError] = useState(null);
  const [idTipoOperacion, setIdTipoOperacion] = useState(null);

  const getIdTipoOperacion = async () => {
    setLoadingData(true);
    if (formValues.idTipoOperacion) {
      setIdTipoOperacion(formValues.idTipoOperacion);
    } else if (id) {
      try {
        const planificacionById = await getPlanificaciones1({ id });
        const idTipoOperacion = planificacionById.data[0].idTipoOperacion;
        setIdTipoOperacion(idTipoOperacion);
      } catch (error) {
        console.log("Error al obtener el ID de tipo de operación:", error);
        setError(error);
        setIdTipoOperacion(null);
      }
    }
    setLoadingData(false);
  };

  useEffect(() => {
    getIdTipoOperacion();
  }, []);

  return {
    error,
    idTipoOperacion,
    loadingData,
  };
}
